import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostAbmeldenCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostAbmeldenCommandService],
  exports: []
})
export class PostAbmeldenCommandServiceModule { }
